/**
 * Development environment configuration
 */
export const environment = {
  production: false,
  NG_ENV_BASE: 'http://dev.mypart.com/mypart-webapp/',
  NG_ENV_BASE_API: 'http://dev.mypart.com/mypart-webapp/api/',
  NG_ENV_BASE_API_SH: 'http://dev.mypart.com/mypart-webapp/api/sh/'
};
